import { render, staticRenderFns } from "./posAddModalInvoice.vue?vue&type=template&id=77d0564a"
import script from "./posAddModalInvoice.vue?vue&type=script&lang=js"
export * from "./posAddModalInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports